export default "__VITE_ASSET__uS16Et4e__"